export default JSON.parse(process.env.VUE_APP_MOBLIE_DOMAIN)